import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { PhysiologicalDataApi } from '../../../apis/PhysiologicalDataApi/PhysiologicalDataApi';
import { IPhysiologicalDataDetails, PhysiologicalDataDetails } from '../PhysiologicalData';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';

export function useGetPhysiologicalDataById() {
    const id = useIdFromRoute();
    return useQuery({
        queryKey: [QueryKeys.physiologicalDataDetails, id],
        queryFn: async () => {
            const results: IPhysiologicalDataDetails = await PhysiologicalDataApi.getPhysiologicalDataById(id!);
            return new PhysiologicalDataDetails(results);
        },
        enabled: !!id,
    });
}
